import type {CSSProperties} from "react";
import type {DataChartProps} from "./types";
import './data-chart.scss';

export default function DataChart({ariaLabel, items, mode, valueLabel = value => value.toLocaleString()}: DataChartProps) {
    const maximum = Math.max(1, ...items.map(item => item.value));

    return (
        <div className={`data-chart data-chart--${mode}`} role="img" aria-label={ariaLabel}>
            {items.map(item => {
                const percent = Math.round(item.value / maximum * 100);
                return (
                    <div className="data-chart__item" key={item.label}>
                        <span className="data-chart__bar" style={{'--data-chart-percent': `${percent}%`} as CSSProperties} aria-hidden="true" />
                        <span className="data-chart__label">{item.label}</span>
                        <span className="data-chart__value">{valueLabel(item.value)}</span>
                    </div>
                );
            })}
        </div>
    );
}
